import { pickFrom } from '@nfctron/nexus-core';

import { type CountryEnumTicketsData, countryEnumTickets } from '@root/lib/constants/country';

/**
 * Company entity type
 * @export
 */
export type CompanyEntity = {
	legalName: string;
	address1?: string;
	address2?: string;
	city?: string;
	postalCode?: string;
	country: CountryEnumTicketsData;
	regNumber?: string;
	taxId?: string;
	vatId?: string;
};

/**
 * Constructs company object
 * @param {Input} input
 * @returns {EventCurrency}
 * @export
 */
export const constructCompanyEntity = <Input extends ConstructCompanyEntityInput = ConstructCompanyEntityInput>(input: Input): CompanyEntity => ({
	...pickFrom(input, 'legalName', 'address1', 'address2', 'postalCode', 'city', 'regNumber', 'vatId', 'taxId'),
	country: countryEnumTickets.get(input.countryId),
});

/**
 * Input type for event currency constructor
 * @export
 */
export type ConstructCompanyEntityInput = {
	legalName: string;
	address1?: string;
	address2?: string;
	city?: string;
	postalCode?: string;
	countryId: number;
	regNumber?: string;
	taxId?: string;
	vatId?: string;
};
